import type { CropId } from "../types";

export type CropDefinition = {
  id: CropId;
  name: string;
  seedPrice: number;
  sellPrice: number;
  growMs: number;
  harvestAmount: number;
  exp: number;
  color: number;
  fruitColor: number;
};

export const CROPS: Record<CropId, CropDefinition> = {
  carrot: {
    id: "carrot",
    name: "แครอต",
    seedPrice: 6,
    sellPrice: 12,
    growMs: 12_000,
    harvestAmount: 2,
    exp: 5,
    color: 0x79b84a,
    fruitColor: 0xf08b38,
  },
  tomato: {
    id: "tomato",
    name: "มะเขือเทศ",
    seedPrice: 10,
    sellPrice: 20,
    growMs: 20_000,
    harvestAmount: 2,
    exp: 8,
    color: 0x5ca747,
    fruitColor: 0xe95d58,
  },
  cabbage: {
    id: "cabbage",
    name: "กะหล่ำปลี",
    seedPrice: 14,
    sellPrice: 30,
    growMs: 32_000,
    harvestAmount: 2,
    exp: 12,
    color: 0x7ebd65,
    fruitColor: 0xa8d882,
  },
};

export const CROP_IDS = Object.keys(CROPS) as CropId[];

export const CAT_FOOD_PRICE = 18;
